import { useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";

export enum SearchPanelMessageType {
    ERROR = "error",
    INFO = "info",
    DEFAULT = "default",
}

export interface SearchPanelMessageProps {
    msgType: SearchPanelMessageType;
    message: string;
    className?: string;
    show: boolean;
    onClearTrigger: () => void;
}

const SearchPanelMessage = (props: SearchPanelMessageProps) => {
    const { msgType, message, className, show, onClearTrigger } = props;
    const [isTextVisible, setIsTextVisible] = useState(false);

    const textColor =
        msgType === SearchPanelMessageType.ERROR ? "text-red-vibrant" : "text-stone-vibrant";
    const classes = clsx("flex items-center gap-1", className, textColor);

    useEffect(() => {
        if (show) {
            setIsTextVisible(true);
            const timer = setTimeout(() => {
                setIsTextVisible(false);
                onClearTrigger();
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [show]);

    return (
        <Transition
            show={isTextVisible}
            leave="transition-opacity duration-50"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            className="mt-6"
        >
            <p className={classes}>
                <ExclamationCircleIcon className="h-5 w-5" />
                <span>{message}</span>
            </p>
        </Transition>
    );
};

export default SearchPanelMessage;
